module.exports = __webpack_public_path__ + "static/img/foot_wx2.fc9f840.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot_wx2.gif
// module id = zyYp
// module chunks = 1